<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
    <div class="mission-content ac crfff">
      <div class="fs50 ">
        <img width="16" src="../../static/images/hm-i1.png">
        <span>Trending</span>
        <img width="20" src="../../static/images/more-info-icon.png">
      </div>
      <div class="css-1asaykn mt50">
        <div class="css-1asaykn trending-img mt20">
          <img width="100%" :src="product[isIndex].image"/>
        </div>
        <div class="trending-content">
          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content">
              <input type="file" @change="convertToBase64_v2" class="file" accept="image/*" mutiple="mutiple">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:60%;" v-if="imageBase64" :src="imageBase64"/>
                  <div class="disflex" v-else>
                    <img width="30" src="../../static/images/transparent.png">
                    <div class="label"> {{ $t('Upload') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="trending-type disflex" @click="isShowLand=true">
            <div class="trd-lf disflex">
              <img class="trd-img" :src="product[isIndex].image" />
              <div class="fs26 ac">{{product[isIndex].title}}</div>
            </div>
            <img class="left-arrow" src="../../static/images/left-arrow.png">
          </div>

            <div class="modal-bg" v-if="isShowLand" @click="isShowLand=false"></div>
          <div class="trending-model" v-if="isShowLand">
            <div class="fs26 choose-title al mt30">{{$t('indexTips2')}} : {{product[isIndex].title}}</div>
            <div class="trending-model-c">
              <div class="land-content al">
                  <div class="trd-li" v-for="(item,index) in product">
                      <div class="two" @click="getSelect(index)">
                          <img v-if="item.is_new" style="position: absolute;right: 0px;top: -20px;width: 40%" src="../../static/images/Festival_icon.png"/>
                          <img class="img" :src="item.image" loading="lazy" />
                          <img class="check-icon" v-if="isIndex==index" src="../../static/images/check.png" />
                          <div class="fs26 ac">{{item.title}}</div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="ac mt30">
            <button style="width: calc(100% - 100px);" @click="uploadImage" class="button">
              <img width="20" src="../../static/images/Generate-icon.png"><strong>{{$t('Generate')}}</strong>
            </button>
          </div>
          <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
            <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--            <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>-->
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
        <div class="image ac" v-if="imageShow">
          <div class="" style="font-size:28px;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt20">
            <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{ $t('Result') }}</span>
            <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div class="input-item2" v-if="isShowResult==1">
                  <input class="input" disabled v-model="detail.url" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
                <div class="input-item2" v-if="isShowResult==2">
                  <input class="input" disabled v-model="detail.original_url" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="detail.original_url" @click="copy" v-if="detail.original_url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog ref="processDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal ac" slot="mdBox">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      processMsg: "",
      product:[],
      isIndex:0,
      isShowLand:false
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
    this.getProduct();
  },
  methods: {
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getProduct() {
        let that = this;
        that.$api.get('/api/index/index_product', null, r => {
            that.$parent.returnCode(r, function() {
                that.product = r.data
            });
        })
    },
    getSelect(index){
      this.isIndex = index
      this.isShowLand = false
    },
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that = this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let {width, height} = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        withScratch: that.withScratch
      }

      // that.$refs.imgDialog.showMaskFun();
      // return;
      that.$parent.loadModal(true);
      that.$api.post('/api/index/old_pic_color', data, r => {
        if (r.code == 0) {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 100);
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    }
  }
}
</script>
<style>
  .oneImageInput{width:90%;background: #2b1d57;}
  .uploadIcon .label{margin-top: 0;margin-left: 0.1rem;}
  .modal-bg {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/page/Trending.vue